<template>
  <v-app id="footer-ticket">
    <footer class="mt-0">
      <section class="ts-newsletter">
        <div class="ts-newsletter-inner">
          <div class="ts-newsletter-text">
            <i class="material-icons">confirmation_number</i>
            <div>
              <h5>Sé el primero en enterarte</h5>
              <p>Recibe noticias, preventas y promociones exclusivas</p>
            </div>
          </div>
          <form class="ts-newsletter-form" @submit.prevent="suscribir">
            <input v-model="correo" type="email" required placeholder="Tu correo electrónico" aria-label="Correo electrónico">
            <button type="submit">Suscríbete</button>
          </form>
          <div class="ts-social">
            <span>Síguenos</span>
            <div>
              <a href="https://instagram.com/ticketshopve?igshid=NGVhN2U2NjQ0Yg==" target="_blank" title="Instagram">
                <font-awesome-icon :icon="['fab', 'instagram']" size="lg"/>
              </a>
              <a href="https://www.facebook.com/people/Ticket-Shop-Ve/61554355611491/?mibextid=LQQJ4d" target="_blank" title="Facebook">
                <font-awesome-icon :icon="['fab', 'facebook-square']" size="lg"/>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div class="footer row row-clearfix">
        <div class="col-md-3 col-lg-3 cont-mini-footer mb-5">
          <h5 class="title-cont-mini-footer"><b>Siguenos</b></h5>
          <br>
          <v-layout row wrap class="list-social-links">
            <v-flex lg1 md1 sm1 xs1>
              <a href="https://www.facebook.com/people/Ticket-Shop-Ve/61554355611491/?mibextid=LQQJ4d" target="_blank">
                <font-awesome-icon :icon="['fab', 'facebook-square']" size="2x"/>
              </a>
            </v-flex>
            <v-flex lg1 md1 sm1 xs1>
              <!--<a href="https://twitter.com/TicketShopCol" target="_blank">
                <font-awesome-icon :icon="['fab', 'twitter']" size="2x"/>
              </a>-->
            </v-flex>
            <v-flex lg1 md1 sm1 xs1>
              <a href="https://instagram.com/ticketshopve?igshid=NGVhN2U2NjQ0Yg==" target="_blank">
                <font-awesome-icon :icon="['fab', 'instagram']" size="2x"/>
              </a>
            </v-flex>
            <!-- <v-flex lg3 md3 sm3 xs3>
              <a href="https://www.youtube.com/channel/UCmYdWEN9mbjAR27TuP9gEwg" target="_blank">
                <font-awesome-icon :icon="['fab', 'youtube']" size="2x"/>
              </a>
            </v-flex> -->
          </v-layout>
        </div>
        <div class="col-md-3 col-lg-3 cont-mini-footer">
          <h5 class="title-cont-mini-footer"><b>Quienes somos</b></h5>
          <br>
          <ul class="list-unstyled list-menu-links">
            <li>
              <router-link :to="{path: '/'}" title="Inicio">
                Inicio
              </router-link>
            </li>
            <li>
              <router-link :to="{path: '/mision'}" title="Mision">
                Mision y Visión
              </router-link>
            </li>

            <li>
              <router-link :to="{path: '/comunicados'}" title="Comunicados">
                Comunicados
              </router-link>
            </li>
            <!--<li>
              <router-link :to="{path: '/contacto'}" title="Contactanos">
                Contactanos
              </router-link>
            </li>-->
            <br>
            <li>
              <router-link :to="{path: '/puntosVenta'}" title="PUNTOS DE VENTA">
                PUNTOS DE VENTA
              </router-link>
            </li>
          </ul>
        </div>

        <div class="col-md-3 col-lg-3 cont-mini-footer">
          <h5 class="title-cont-mini-footer"><b>TicketShop Venezuela</b></h5>
          <br>
          <ul class="list-unstyled list-menu-links">
            <li>
              <router-link :to="{path: '/terminoscondiciones'}" title="Terminos y Condiciones">
                Terminos y Condiciones
              </router-link>
            </li>
            <li>
              <a href="/pqr" title="Solicitud de Peticiones, Quejas y Reclamos">
                Solicitud de Peticiones, Quejas y Reclamos
              </a>
            </li>
            <!--<li>
              <router-link :to="{path: '/politicatratamiento'}"
                           title="Politica de tratamiento de proteccion de datos personales">
                Politica de tratamiento de proteccion de datos personales
              </router-link>
            </li>
            <li>
              <a href="https://www.sic.gov.co/asesoria-en-linea">SIC</a>
            </li>-->
          </ul>
        </div>
        <div class="col-md-3 col-lg-3 cont-mini-footer text-center">
          <h5 class="title-cont-mini-footer"><b>Si continua en esta pagina acepta los</b></h5>
          <router-link :to="{path: '/terminoscondiciones'}" title="Terminos y Condiciones" class="title-cont-mini-footer">Términos y condiciones de uso</router-link>
        </div>
      </div>
      <section class="aliados slider">
        <div class="slide div-slide-alidos" title="" v-for="aliado in aliados">
          <img :src="aliado.src" :class="cssRefresh ? 'img-slide-aliados' : ''">
        </div>
      </section>
      <br>
      <section>
        <div class="copyright">
          <router-link :to="{path: '/'}" class="navbar-brand" title="TicketShop" tag="a">
            <img class="logo" src="../../../public/images/logo-ticketshop-ve.png" alt="TicketShop VE" style="width: 180px; height: auto;">
          </router-link>
          <small>Ticketshopve.com {{ new Date().getFullYear() }}. Todos los derechos
          </small><br>

        </div>
      </section>

    </footer>
  </v-app>
</template>
<script>
import axios from 'axios';
import swal from 'sweetalert';
import { configApi } from '../../api/configApi';
import { headers } from '../../api/headers';
export default {
  mounted() {
    
  },
  async beforeCreate() {
    await    axios.get(`${configApi.apiUrl}buscarimagenaliados`,null,{headers: headers})
      .then(response => {
        this.ftaliados = response.data.data
        
        this.aliados =   this.ftaliados.map(item => { 
                return { src: item.url };
              }); 

        this.cssRefresh = true;

          $(document).ready(function () {
            $('.aliados').slick({
              slidesToShow: 6,
              slidesToScroll: 1,
              autoplay: true,
              autoplaySpeed: 3000,
              arrows: false,
              dots: false,
              vertical: false,
              pauseOnHover: false,
              responsive: [{
                breakpoint: 768,
                settings: {
                  slidesToShow: 4
                }
              }, {
                breakpoint: 520,
                settings: {
                  slidesToShow: 3
                }
              }],
              variableWidth: true,
            });
          });
      })
  },
  data() {
    return {
      aliados: [],
      ftaliados: [],
      cssRefresh: false,
      correo: ''
    }
  },
  methods: {
    suscribir() {
      // TODO: conectar con el endpoint de suscripción cuando exista en el backend
      swal("¡Muy pronto!", "La suscripción al boletín estará disponible próximamente.", "info");
      this.correo = '';
    }
  }
};
</script>
<style>
footer {
  background-color: #0b0b0b;
  margin-top: 40px;
}
.ts-newsletter {
  background: linear-gradient(90deg, #111 0%, #1b1710 50%, #111 100%);
  border-top: 2px solid #c8962e;
  border-bottom: 1px solid rgba(212, 165, 55, .25);
}
.ts-newsletter *:not(.material-icons):not(.v-icon):not(.mdi):not(.svg-inline--fa) {
  font-family: 'Montserrat', Raleway, sans-serif;
}
.ts-newsletter-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 26px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
}
.ts-newsletter-text {
  display: flex;
  align-items: center;
  gap: 16px;
  color: #fff;
}
.ts-newsletter-text .material-icons {
  font-size: 54px;
  color: #d4a537;
  transform: rotate(-20deg);
}
.ts-newsletter-text h5 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
}
.ts-newsletter-text p {
  margin: 4px 0 0;
  font-size: 13px;
  color: #ccc;
}
.ts-newsletter-form {
  display: flex;
  flex: 1;
  max-width: 420px;
  min-width: 260px;
  background: #fff;
  border-radius: 999px;
  overflow: hidden;
}
.ts-newsletter-form input {
  flex: 1;
  border: 0;
  outline: none;
  padding: 12px 20px;
  font-size: 13px;
  min-width: 0;
}
.ts-newsletter-form button {
  border: 0;
  padding: 0 26px;
  background: linear-gradient(180deg, #f6dc8c 0%, #d4a537 55%, #b8862a 100%);
  color: #1a1a1a;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 13px;
}
.ts-social {
  color: #fff;
  border-left: 1px solid rgba(255, 255, 255, .25);
  padding-left: 24px;
}
.ts-social span {
  display: block;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 6px;
}
.ts-social a {
  margin-right: 12px;
}
.ts-social a:hover {
  opacity: .75;
}
@media (max-width: 767px) {
  .ts-newsletter-inner {
    flex-direction: column;
    align-items: stretch;
    padding: 22px 16px;
  }
  .ts-newsletter-form {
    max-width: none;
  }
  .ts-social {
    border-left: 0;
    padding-left: 0;
    text-align: center;
  }
}
#footer-ticket .v-application--wrap{
  min-height: auto;
}
.footer {
  padding: 35px 15px 0px 15px;
  color: white;
}

.list-social-links a {
  color: white;
}

.list-social-links a:hover {
  color: white;
  opacity: .8;
}

.title-cont-mini-footer {
  text-transform: uppercase;
  /* color: #ffc107; */
  color: #9E9E9E;
}

.list-menu-links a {
  color: white;
}

.list-menu-links a:hover {
  color: white;
  opacity: .8;
}

.cont-mini-footer {
  margin-bottom: 15px;
}

.copyright {
  color: white;
  text-align: center;
  padding: 10px 10px;
}

div.div-slide-alidos {
  width: 145px !important;
  text-align: center !important;
}

div > img.img-slide-aliados {
  width: 120px !important;
  height: 90px !important;
}
.v-application a{
  color: white !important;
}
</style>